import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { buildGetString } from './stringUtils'

type DPContext = {
  getString: ReturnType<typeof buildGetString>
  pageType: WpsRuntime.atv.wps.PageType
  subPageType?: WpsRuntime.atv.wps.SubPageType
}

const DpWidgetContext = React.createContext<DPContext>(null)

export { DpWidgetContext }